import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid col-span-1 lg:grid-cols-5 gap-16" }
const _hoisted_2 = { class: "lg:col-span-2 space-y-6 lg:text-right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Questions? We got answers.")
], -1)
const _hoisted_4 = { class: "lg:text-end" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Here are the most common and important questions to get you started on purchasing a ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" token. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("More Answers")
const _hoisted_8 = { class: "lg:col-span-3" }
const _hoisted_9 = { class: "flex flex-col space-y-2" }

import DisclosureItem from "@/components/disclosure/DisclosureItem.vue";
import AppButton from "@/components/app/AppButton.vue";
import { routes } from "@/constants/";
import ContainerSection from "@/components/section/ContainerSection.vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeFAQ',
  setup(__props) {

const questions = {
    "How many Dripversity NFTs are there?":
        "There are 250 Dripversity tokens for this collection.",
    "How can I claim my Dripversity Campus airdrop?":
        "In order to be eligible for the Dripversity Campus airdrop you have to buy a Dripversity NFT of the collection drop on Foundation. After the drop reveal you can connect your wallet that holds one or more Dripversity NFTs to claim your Campus airdrop.",
    "How do I purchase a Dripversity NFT?":
        "In order to purchase a Dripversity NFT, you will need to conduct two important steps. First, you will need to purchase ETH from a crypto-currency exchange such as Coinbase, Kraken, or Binance. Once you have completed that step, you will need to transfer your ETH into a non-custodial digital wallet like MetaMask or WalletConnect compatible wallets. These wallets connect to the Foundation website and allow you to purchase an NFT of the Dripversity drop. For your reference, here are blog posts outlining in detail how to set up a crypto wallet, as well as the basic steps to take to send ETH to your wallet.",
    "Can I resell my Dripversity NFT?":
        "Yes. Dripversity tokens can be resold on NFT marketplaces such as OpenSea and Rarible etc. If a Dripversity token is resold there will be a 5% royalty fee to Dripversity.",
    "Will the NFTs be sold on open marketplaces?":
        "Primary sales (Minting) of Dripversity NFTs will be on Foundation.app. DRIPVERSITY tokens will appear on secondary marketplaces like OpenSea and Rarible etc. for resale purchase. Dripversity NFTs will adhere to the ERC-721 standard.",
    "What blockchain are these NFTs minted on?":
        "NFTs are minted on ERC-721 compliant contracts deployed to the Ethereum blockchain.",
};

return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createBlock(ContainerSection, { id: "faq" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, [
              _hoisted_5,
              _createVNode(DripversityIcon, { class: "text-dripversity" }),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(AppButton, {
              to: _unref(routes).support['How to create a wallet']
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])), [
          [
            _directive_animate,
            void 0,
            void 0,
            { stagger: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(questions, (answer, question) => {
              return _createElementVNode("li", {
                class: "flex flex-col",
                key: question
              }, [
                _createVNode(DisclosureItem, null, {
                  question: _withCtx(() => [
                    _createTextVNode(_toDisplayString(question), 1)
                  ]),
                  answer: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(answer), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            }), 64))
          ])), [
            [
              _directive_animate,
              void 0,
              void 0,
              { stagger: true }
            ]
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})